import { apiClient } from './client';
import { HrRequest } from '../types/hr-requests';

export const hrRequestApi = {
  mine: () => apiClient.get<{ data: HrRequest[] }>('/api/hr-requests/mine'),
  create: (input: { requestType: string; details?: string }) => apiClient.post<{ data: { id: number } }>('/api/hr-requests', input),
  createProfileUpdate: (proposedChanges: Record<string, string | null>) =>
    apiClient.post<{ data: { id: number; status: string } }>('/api/hr-requests/profile-update', { proposedChanges }),
  createCompensationRequest: (input: { newBaseSalary: number; salaryCurrency: string; effectiveDate: string; reason: string }) =>
    apiClient.post<{ data: { id: number; status: string } }>('/api/hr-requests/compensation', input),
  createProjectAssignmentRequest: (input: { projectId: number; roleOnProject?: string; allocationPercentage?: number; startDate: string }) =>
    apiClient.post<{ data: { id: number; status: string } }>('/api/hr-requests/project-assignment', input),
  pending: () => apiClient.get<{ data: HrRequest[] }>('/api/hr-requests/pending'),
  getById: (id: number) => apiClient.get<{ data: HrRequest }>(`/api/hr-requests/${id}`),
  resolve: (id: number, input: { decision: 'approved' | 'rejected'; resolutionNotes?: string }) =>
    apiClient.post<{ data: { status: string } }>(`/api/hr-requests/${id}/resolve`, input),
  complete: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/hr-requests/${id}/complete`),
  return: (id: number, comment: string) => apiClient.post<{ data: { status: string } }>(`/api/hr-requests/${id}/return`, { comment }),
  resubmit: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/hr-requests/${id}/resubmit`),
};
